import React , {useState , useEffect}from 'react'

import Carousel from 'react-grid-carousel'

import CarouserCard from './CarouserCard';

import getGlobal from '../../setglobal';

import axios from 'axios'


export default function Carousel01( {show}) {

  const [screenSize, setScreenSize] = useState(1);
  const [cards,setcards] = useState([]) ;


  useEffect(() => {

    console.log( getGlobal() + 'getpromos') ;

    axios(  getGlobal() + 'getpromos' )
    .then( (response) => {

      setcards( response.data) ;

    })
    .catch( (e) => {

      console.log( e ) ;

    })
    .finally(

    )



  } , [])

 
  return (


    <div className='px-5'>

    <Carousel cols={screenSize} rows={1} gap={20} loop  >

      {
        cards.map( (item,index) => {  
          return ( 
            <Carousel.Item key={item.sku} >
          
              <CarouserCard url={item.image} sku={item.sku} show={show} 
                price={(item.price*17.0959)*1.16} pricepromo={item.pricepromo} ccomment={item.ccomment} titlesp={item.titlesp}>

              </CarouserCard>
              
              {/* <img src={item.url} key={index} alt='' height='100px'></img> */}

            </Carousel.Item> 

          
          )
          
        })
         
      }
    
    </Carousel>
    </div>
  )
}


/*
[
    {
      url : 'https://snap-on-products-hr.imgix.net/XB1820A.jpg' ,
      

    },
    {
      url : 'https://snap-on-products-hr.imgix.net/XDH1820A.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/XOM1719.jpg'

    },
    {
      url :'https://snap-on-products-hr.imgix.net/XOM1719.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/XS1618A.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/YA160A.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/YA3080.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/YA452.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/YA6010.jpg'
    },
    {
      url : 'https://snap-on-products-hr.imgix.net/YA745A.jpg'
    }



  ]

*/